import React from 'react';
import { LicenseFeature } from '@/types/license';
import { FeatureItem } from './FeatureItem';

interface FeatureListProps {
  features: LicenseFeature[];
  groupName: string;
}

export const FeatureList: React.FC<FeatureListProps> = ({ features, groupName }) => {
  const isSpecialGroup = groupName === 'Copilot';

  return (
    <div className={`mb-6 p-4 rounded-lg ${
      isSpecialGroup ? 'bg-blue-50' : ''
    }`}>
      <h4 className={`font-semibold mb-2 ${
        isSpecialGroup ? 'text-blue-900' : 'text-gray-800'
      }`}>
        {groupName}
      </h4>
      <ul className="space-y-2">
        {features.map((feature) => (
          <FeatureItem key={feature.name} feature={feature} />
        ))}
      </ul>
    </div>
  );
};